import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { Loader2 } from "lucide-react";
import { useState } from "react";

interface ReceiptPreviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  receiptUrl: string | null;
  title?: string;
}

const ReceiptPreviewDialog = ({
  isOpen,
  onClose,
  receiptUrl,
  title = "Comprobante",
}: ReceiptPreviewDialogProps) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl gap-6">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        {receiptUrl && (
          <>
            {isLoading && (
              <div className="absolute inset-0 flex justify-center items-center z-10 bg-white/70">
                <Loader2 className="animate-spin w-6 h-6 text-muted-foreground" />
              </div>
            )}

            <div className="flex justify-center overflow-auto custom-scrollbar max-h-[70vh]">
              <img
                src={receiptUrl}
                alt="Comprobante"
                onLoad={() => setIsLoading(false)}
                className={`max-w-full h-auto object-scale-down transition-opacity duration-300 ${
                  isLoading ? "opacity-0" : "opacity-100"
                }`}
              />
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReceiptPreviewDialog;
